import { createColumnHelper } from '@tanstack/react-table';

import { OmniNodeRowData } from '../types';

export const columnHelper = createColumnHelper<OmniNodeRowData>();
